module.exports = __webpack_public_path__ + "static/media/Mentorship-9.7e15f39d.jpg";